import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";

function PageWrapper({ children, hideNav }) {
  return (
    <>
      <div className="px-[4%] md:px-[10%] pb-6 sm:pb-8">
        {!hideNav && <Navbar />}
        <div className={!hideNav ? "pt-28 sm:pt-32 md:pt-36" : "pt-4 sm:pt-6"}>{children}</div>
      </div>
      <Footer />
    </>
  );
}

export default PageWrapper;
